import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';

import Privacy from './Privacy/Privacy';
import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import ImagePanel from '@components/ImagePanel/ImagePanel';
import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import ImportImages from '@src/importImages';

const exteriorImg = ImportImages('/legal/1.jpg');

class Legal extends Component {
  render() {
    const scrollContainerProps = {
      pageHeight: this.props.pageHeight,
      autoScroll: {
        active: 1,
        delay: 1000
      },
      hideNavDots: false,
      pageWidth: this.props.pageWidth
    };

    return (
      <Fragment>
        <Helmet>
          <title>Legal | JetSuite</title>
          <meta name="description" content={'Privacy Policy'} />
        </Helmet>
        <ScrollContainer {...scrollContainerProps}>
          <ImagePanel
            className={'img-bottom'}
            id={'legal-imagepanel'}
            screenHeight={this.props.pageHeight}
            image={exteriorImg}
            alt={'exteriorImg'}
          />

          <Privacy
            id={'privacy'}
            pageWidth={this.props.pageWidth}
            heightSm={this.props.heightSm}
          />
          <TermsAndConditions id={'terms'} heightSm={this.props.heightSm} />
        </ScrollContainer>
      </Fragment>
    );
  }
}

export default Legal;



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.jsx